import {Department} from '@app/core/models/department.model';
import {User} from '@app/core/models/user.model';
import {DayNote} from '@app/core/models/day-note.model';
import {Pagination} from '@app/core/models/pagination.model';

export interface IPunchClockState {
	department: Department;
	users: User[];
	dayNotes: DayNote[];
	dayNotesPagination: Pagination;
	usersPagination: Pagination;
	isUsersLoading: boolean;
	isDayNotesLoading: boolean;
}

export const initialPunchClockState: IPunchClockState = {
	department: undefined,
	usersPagination: undefined,
	dayNotesPagination: undefined,
	dayNotes: [],
	users: [],
	isUsersLoading: false,
	isDayNotesLoading: false,
};
